import React from "react";
import { useLocalization } from "gatsby-theme-i18n";
import { navigate } from "gatsby";

export const useNavigate = () => {
  const { locale, defaultLang } = useLocalization();

  return {
    navigate: (path, options) =>
      defaultLang === locale
        ? navigate(`${path}`, options)
        : navigate(`/${locale}${path}`, options),
  };
};
